<script lang="ts">
  export let size: any = 18;
  export let stroke_width = 1;
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 18 18"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  stroke-width={stroke_width}
>
  <g id="vuesax/linear/trash">
    <g id="vuesax/linear/trash_2">
      <g id="trash">
        <path
          id="Vector"
          d="M15.75 4.48499C13.2525 4.23749 10.74 4.10999 8.235 4.10999C6.75 4.10999 5.265 4.18499 3.78 4.33499L2.25 4.48499"
          class={$$props.class || "stroke-garden-grey-600"}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          id="Vector_2"
          d="M6.375 3.7275L6.54 2.745C6.66 2.0325 6.75 1.5 8.0175 1.5H9.9825C11.25 1.5 11.3475 2.0625 11.46 2.7525L11.625 3.7275"
          class={$$props.class || "stroke-garden-grey-600"}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          id="Vector_3"
          d="M14.1375 6.85498L13.65 14.4075C13.5675 15.585 13.5 16.5 11.4075 16.5H6.59249C4.49999 16.5 4.43249 15.585 4.34999 14.4075L3.86249 6.85498"
          class={$$props.class || "stroke-garden-grey-600"}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          id="Vector_4"
          d="M7.7475 12.375H10.245"
          class={$$props.class || "stroke-garden-grey-600"}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          id="Vector_5"
          d="M7.125 9.375H10.875"
          class={$$props.class || "stroke-garden-grey-600"}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </g>
  </g>
</svg>
